import axios from './index';

export const _getTopupInvoice = (filterObj = {}) => {
  const { fromDate, toDate } = filterObj;
  return axios.get(
    `public/v1/app/get-topup/-/${fromDate || '0'}/${toDate || 999999999999999}`
  );
};

export const _filterTopupInvoice = (reqObj) => {
  return axios.get(
    `public/v1/app/get-topup/${reqObj.data.issuerID}/${reqObj.data.fromDate}/${reqObj.data.toDate}`
  );
};

export const _addSystemTopup = (reqObj) => {
  return axios.post(`public/v1/app/dash-point`, reqObj);
};

export const _addBankTopup = (reqObj) => {
  return axios.post(`public/v1/app/get-invoice`, reqObj);
};
